import React from 'react'
import { LanguageProvider } from './src/contexts/LanguageContext'

export const wrapRootElement = ({ element }) => (
  <LanguageProvider>{element}</LanguageProvider>
)